import React from 'react'
import ClassNames from 'classnames'
import PropTypes from 'prop-types'

import { Slider, Rail, Handles, Tracks, Ticks } from 'react-compound-slider'
//https://www.npmjs.com/package/react-compound-slider

import NumberFormat from 'react-number-format'
//https://www.npmjs.com/package/react-number-format

import { Textfit } from 'react-textfit'
//https://www.npmjs.com/package/react-textfit

import { Input } from '../../components'

import {
  SliderCompoundStyle,
  RailOuterStyle,
  RailInnerStyle,
  TickWrapperStyle,
  TrackStyle,
  HandleWrapperStyle,
} from './styled'
import { toastFail } from '../../helpers'

// *******************************************************
// SLIDER RAIL COMPONENT
// *******************************************************
function SliderRail({ getRailProps }) {
  return (
    <React.Fragment>
      <RailOuterStyle className="rail-outer" {...getRailProps()} />
      <RailInnerStyle className="rail-inner" />
    </React.Fragment>
  )
}

SliderRail.propTypes = {
  getRailProps: PropTypes.func.isRequired,
}

// *******************************************************
// HANDLE COMPONENT
// *******************************************************
function Handle({
  domain: [min, max],
  handle: { id, value, percent },
  disabled,
  getHandleProps,
}) {
  return (
    <HandleWrapperStyle percent={percent}>
      <div className="handler-control" {...getHandleProps(id)} />
      <div
        className="handler"
        role="slider"
        aria-valuemin={min}
        aria-valuemax={max}
        aria-valuenow={value}
      />
    </HandleWrapperStyle>
  )
}

Handle.propTypes = {
  domain: PropTypes.array.isRequired,
  handle: PropTypes.shape({
    id: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired,
    percent: PropTypes.number.isRequired,
  }).isRequired,
  getHandleProps: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
}

Handle.defaultProps = {
  disabled: false,
}

// *******************************************************
// TRACK COMPONENT
// *******************************************************
function Track({ source, target, getTrackProps, disabled }) {
  return (
    <TrackStyle
      source={source}
      target={target}
      disabled={disabled}
      {...getTrackProps()}
    />
  )
}

Track.propTypes = {
  source: PropTypes.shape({
    id: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired,
    percent: PropTypes.number.isRequired,
  }).isRequired,
  target: PropTypes.shape({
    id: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired,
    percent: PropTypes.number.isRequired,
  }).isRequired,
  getTrackProps: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
}

Track.defaultProps = {
  disabled: false,
}

// *******************************************************
// TICK COMPONENT
// *******************************************************
function Tick({ tick, count, format }) {
  return (
    <TickWrapperStyle tick={tick} count={count}>
      <div className="tick-line" />
      <div className="tick-number">{format(tick.value)}</div>
    </TickWrapperStyle>
  )
}

Tick.propTypes = {
  tick: PropTypes.shape({
    id: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired,
    percent: PropTypes.number.isRequired,
  }).isRequired,
  count: PropTypes.number.isRequired,
  format: PropTypes.func.isRequired,
}

Tick.defaultProps = {
  format: d => d,
}

// *******************************************************
// SLIDER COMPOUND COMPONENT
// *******************************************************
export class SliderCompound extends React.PureComponent {
  // static Rail = Rail
  // static Handles = Handles
  // static Tracks = Tracks
  // static Ticks = Ticks

  constructor(props) {
    super(props)
    this.state = {
      // values: this.props.defaultValues.slice(),
      update: null,
      // prevValues: this.props.defaultValues.slice(),
      // prevUpdate: this.props.defaultValues.slice(),
      width: window.innerWidth,
    }
  }

  // for demo Start
  // state = { width: window.innerWidth }

  updateDimensions = () => {
    this.setState({ width: window.innerWidth })
  }
  componentDidMount() {
    window.addEventListener('resize', this.updateDimensions)
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions)
  }
  calZoomReverse = width => {
    if (width < 1024) return 2
    else if (1024 <= width <= 1920) {
      let temp = (width - 1024) / (896 * 2)
      let tempReverse = 1 / (1 - (0.5 - temp.toFixed(2)))
      return tempReverse.toFixed(2)
    } else return 1
  }
  calZoom = width => {
    if (width < 1024) return 2
    else if (1024 <= width <= 1920) {
      let temp = (width - 1024) / (896 * 2)
      return 1 - (0.5 - temp.toFixed(2))
    } else return 1
  }
  // for demo End

  onUpdate = update => {
    this.setState({ update })
  }

  onChange = values => {
    this.props.onChange(values)
  }

  setDomain = domain => {
    this.setState({ domain })
  }

  toggleReverse = () => {
    this.setState(prev => ({ reversed: !prev.reversed }))
  }

  render() {
    const {
      className,
      isHideTicks,
      isDisplayValue,
      domain,
      values,
      // defaultValues,
      step,
      mode,
      valueUnit,
      disabled,
    } = this.props

    // const { update } = this.state
    const update = this.state.update || this.props.values
    return (
      <SliderCompoundStyle
        className={ClassNames(
          'slider-wrapper',
          { 'is-disabled': disabled },
          className
        )}
        //demoZoomReverse={this.calZoomReverse(this.state.width)}
        //demoZoom={this.calZoom(this.state.width)}
      >
        <div className="display-values">
          {/* {valueUnit && <div className="value-unit">{valueUnit}</div>} */}
          <div className="values">
            {update.map((value, i) => (
              <div className="value" key={i}>
                <NumberFormat
                  value={value}
                  displayType={'input'}
                  thousandSeparator={true}
                  customInput={Input}
                  placeholder="0"
                  onFocus={e => {
                    if (e.target.value === '0') {
                      let newUpdate = [...update]
                      newUpdate[i] = ''
                      this.onUpdate(newUpdate)
                    }
                  }}
                  onValueChange={e => {
                    if (e.floatValue > -1) {
                      let newUpdate = [...update]
                      newUpdate[i] = e.floatValue
                      this.onUpdate(newUpdate)
                    }
                  }}
                  onKeyDown={e => {
                    if (e.key == 'Enter') {
                      // this.onChange(update)
                      if (update[0] > update[1]) {
                        toastFail('Please enter a valid value.')
                      } else {
                        this.onChange(update)
                      }
                    }
                  }}
                />
              </div>
            ))}
          </div>
        </div>

        <Slider
          onUpdate={this.onUpdate}
          onChange={this.onChange}
          {...this.props}
          mode={mode}
          step={step}
          domain={domain}
          values={values}
          className={ClassNames('slider', className)}
          disabled={disabled}
        >
          <Rail>
            {({ getRailProps }) => <SliderRail getRailProps={getRailProps} />}
          </Rail>

          <Handles>
            {({ handles, getHandleProps }) => (
              <div className="slider-handles">
                {handles.map(handle => (
                  <Handle
                    key={handle.id}
                    handle={handle}
                    domain={domain}
                    getHandleProps={getHandleProps}
                  />
                ))}
              </div>
            )}
          </Handles>

          <Tracks left={false} right={false}>
            {({ tracks, getTrackProps }) => (
              <div className="slider-tracks">
                {tracks.map(({ id, source, target }) => (
                  <Track
                    key={id}
                    source={source}
                    target={target}
                    getTrackProps={getTrackProps}
                  />
                ))}
              </div>
            )}
          </Tracks>

          {!isHideTicks && (
            <Ticks count={10}>
              {({ ticks }) => (
                <div className="slider-ticks">
                  {ticks.map(tick => (
                    <Tick key={tick.id} tick={tick} count={ticks.length} />
                  ))}
                </div>
              )}
            </Ticks>
          )}
        </Slider>
      </SliderCompoundStyle>
    )
  }
}

SliderCompound.defaultProps = {
  isHideTicks: true,
  isDisplayValue: false,
  // domain: [0, 1000],
  // defaultValues: [100, 1000],
  step: 1,
  mode: 2,
}
